<template>
  <html>

  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <link rel="icon" type="image/png" href="favicon.png" />
    <title>Restó APP</title>
  </head>

  <body class="home-page">
    <Header :isRestoCompleto=true></Header>
    <div class="col-lg-12 mx-auto p-3 py-md-5">
      <main>
        <div class="container" style="display: flex; flex-direction: row; justify-content: space-between; gap: 20px;">

          <div style="flex: 1; border: 1px solid #ccc; padding: 15px; border-radius: 22px;">
            <div style="display: flex; justify-content: space-between; gap: 20px;">

              <div style="display: flex; flex-direction: column; gap: 10px;">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="radio1" v-model="fechaOpcion" value="hoy">
                  <label class="form-check-label" for="radio1">Hoy</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="radio2" v-model="fechaOpcion" value="manana">
                  <label class="form-check-label" for="radio2">Mañana</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="radio3" v-model="fechaOpcion" value="semana">
                  <label class="form-check-label" for="radio3">Semana</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="radio4" v-model="fechaOpcion" value="mes">
                  <label class="form-check-label" for="radio4">Mes</label>
                </div>
              </div>

              <div style="display: flex; flex-direction: column; gap: 10px;">
                <div>
                  <div class="form-check" style="display: inline-block; margin-right: 20px;">
                    <input class="form-check-input" type="radio" id="checkboxHorizontal1" value="telefono"
                      v-model="buscarPorMedio">
                    <label class="form-check-label" for="checkboxHorizontal1">Movil</label>
                  </div>
                  <div class="form-check" style="display: inline-block;">
                    <input class="form-check-input" type="radio" id="checkboxHorizontal2" value="email"
                      v-model="buscarPorMedio">
                    <label class="form-check-label" for="checkboxHorizontal2">Email</label>
                  </div>
                </div>

                <input :placeholder="'Buscar...'" @input="inputMovilEmail($event.target.value)" type="text"
                  class="form-control mt-2" :disabled="!isBuscarPorMedioSelected">



              </div>
            </div>
          </div>


          <div
            style="flex: 1; border: 1px solid #ccc; padding: 15px; display: flex; justify-content: space-between; gap: 20px; border-radius: 22px;">

            <div style="display: flex; flex-direction: column; gap: 10px;">
              <div>
                <div class="form-check" style="display: inline-block; margin-right: 20px;">
                  <input class="form-check-input" type="radio" id="registroRadio" v-model="buscarPor" value="registro">
                  <label class="form-check-label" for="registroRadio">Registro</label>
                </div>
                <div class="form-check" style="display: inline-block;">
                  <input class="form-check-input" type="radio" id="reservaRadio" v-model="buscarPor" value="reserva">
                  <label class="form-check-label" for="reservaRadio">Reserva</label>
                </div>
              </div>

              <div style="display: flex; align-items: center; gap: 10px;">
                <span>Desde:</span>
                <date-picker v-model="fechaDesde" valueType="format" format="DD-MM-YYYY"
                  :disabled="buscarPor === ''"></date-picker>
              </div>

              <div style="display: flex; align-items: center; gap: 10px; margin-top: 10px;">
                <span>Hasta:</span>
                <date-picker v-model="fechaHasta" valueType="format" format="DD-MM-YYYY"
                  :disabled="buscarPor === ''"></date-picker>
              </div>

            </div>



            <div
              style=" display: flex; flex-direction: column; flex: 1; align-items: stretch; justify-content: space-between;">
              <div style="display: flex; flex-direction: column; gap: 10px;">
                <p>Estado:</p>
                <select class="form-select form-select-sm col" v-model="estadoSelec">
                  <option></option>
                  <option value="TODAS" :selected="true">TODAS</option>
                  <option v-for="(estado, index) in estados" :key="index">{{ estado }}</option>
                </select>
              </div>
              <div style="display: flex; gap: 10px; align-items: center;">
                <button type="button" class="btn btn-secondary" v-on:click="limpiarFiltros()">Limpiar filtros</button>
                <button type="button" class="btn btn-primary" v-on:click="buscar(1)">Buscar</button>
              </div>
            </div>
          </div>
        </div>

        <br />
        <h3>Reservas</h3>

        <hr class="" />

        <table class="table table-responsive table-striped align-middle">
          <thead>
            <tr>
              <th scope="col">Codigo</th>
              <th scope="col">Fecha de Registro</th>
              <th scope="col">Fecha de Reserva</th>
              <th scope="col">Horario</th>

              <th scope="col">Cantidad Mayores</th>
              <th scope="col">Cantidad Menores</th>
              <th scope="col">Nombre</th>
              <th scope="col">Telefono</th>
              <th scope="col">Email</th>
              <th scope="col">Estado</th>
              <th scope="col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="reservas.length == 0">
              <td colspan="11">
                <h4 class="text-center">NO DATA</h4>
              </td>
            </tr>
            <tr v-for="(reserva, index) in filtrado" :key="index">
              <th scope="row">{{ reserva.registro ? reserva.id : reserva.id + '(*)' }}</th>
              <th scope="row">{{ reserva.registro }}</th>
              <th scope="row">{{ reserva.fecha }}</th>
              <th scope="row">{{ reserva.horario.toString().padStart(2, '0') + ':' + reserva.minutos.toString().padStart(2, '0') }} Hs.</th>
 
              <td>{{ reserva.comensales_mayores }}</td>
              <td>{{ reserva.comensales_menores }}</td>
              <td>{{ mostrarNombre(reserva) }}</td>
              <td>{{ mostrarTelefono(reserva) }}</td>
              <td>{{ mostrarEmail(reserva) }}</td>
              <td>{{ mostrarEstado(reserva) }}</td>
              <td>
                <button type="button" class="btn btn-primary mb-3" style="margin: 0 !important"
                  v-on:click="verReserva(reserva.id, reserva.email)">
                  Ver
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-3">
            <div class="input-group mb-3">
              <label class="input-group-text" for="inputGroupSelect01">Resultados por pagina: &nbsp;</label>
              <select v-model="pageSizeSelected" @change="buscar(currentPage)" class="form-select">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="-1">Todos</option>
              </select>
            </div>
          </div>
          <div class="col-5">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="pageSizeSelected"
              @change="buscar($event)" last-number></b-pagination>
          </div>
          <div class="col-3">
            <h6> <b>Total resultados: {{ this.totalRows }} </b></h6>
          </div>
        </div>

        <div class="row">
          <div class="col-6" style="padding-top: 15px;">
            <ExcelReservasTodo :exportar="true" :data="reservas" :request="this.requestLast" :file="filename">
            </ExcelReservasTodo>

          </div>

          <div class="col-6">
            <button type="button" class="btn btn-primary" v-on:click="exportarPDF(1)">
              Exportar a Pdf
            </button>

          </div>

        </div>


      </main>
      <Footer />
    </div>
  </body>

  </html>
</template>

<script>
import axios from "axios";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ExcelReservasTodo from "../components/ExcelReservasTodo.vue";
import { saveAs } from 'file-saver';
export default {
  name: "Reservas",
  components: { Header, Footer, DatePicker, ExcelReservasTodo },
  data: function () {
    return {
      filename: "",
      buscarPorMedio: '',
      fechaOpcion: null,
      buscarPorRegistro: false,
      buscarPorReserva: false,
      fechaDesde: "",
      fechaHasta: "",
      estados: [],
      estadoSelec: "VIGENTE",
      email: "",
      buscarPor: '',
      telefono: "",
      reservas: [],
      filtrado: [],
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      pageSizeSelected: 10,
      currentPage: 0,
      totalRows: 0,
      requestLast: null,
    };
  },
  computed: {
    isBuscarPorMedioSelected() {
      return this.buscarPorMedio === 'telefono' || this.buscarPorMedio === 'email';
    },
  },
  methods: {
    convertDataObjectUrl(data) {
      return Object.keys(data)
        .map(function (k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);

        })
        .join("&");
    },
    inputMovilEmail(value) {
      if (this.buscarPorMedio === 'telefono') {
        this.telefono = value;
      } else if (this.buscarPorMedio === 'email') {
        this.email = value;
      }
    },
    mostrarEstado(reserva) {
      if (reserva.estado == "PENDIENTE")
        return "PENDIENTE";

      return reserva.estado;
    },
    mostrarNombre(reserva) {
      if (reserva.usuario) {
        return reserva.usuario.nombre;
      }
      return reserva.usuarioNoRegistrado.nombre;
    },
    mostrarTelefono(reserva) {
      if (reserva.usuario) {
        return reserva.usuario.telefono;
      }
      return reserva.usuarioNoRegistrado.telefono;
    },
    mostrarEmail(reserva) {
      if (reserva.usuario) {
        return reserva.usuario.mail;
      }
      return reserva.usuarioNoRegistrado.email;
    },

    buscar(page) {


      this.currentPage = page;
      this.filtrado = [];
      this.totalRows = 0;

      let request = {
        size: this.pageSizeSelected,
        page: page - 1,
        telefono: this.telefono,
        email: this.email,
        fechaOpcion: this.fechaOpcion,
        buscarPorRegistro: this.buscarPor === 'registro',
        buscarPorReserva: this.buscarPor === 'reserva',
        estado: this.estadoSelec
      };

      if (this.buscarPor === 'registro') {
        request.fechaRegistroDesde = this.fechaDesde;
        request.fechaRegistroHasta = this.fechaHasta;
      } else if (this.buscarPor === 'reserva') {
        request.fechaReservaDesde = this.fechaDesde;
        request.fechaReservaHasta = this.fechaHasta;
      }

      this.requestLast = request;



      axios.get("/getReservas?" + this.convertDataObjectUrl(request)).then((data) => {
        if (data.status == 200) {
          data.data.items.forEach((reserva) => {
            Object.keys(reserva).forEach(
              (k) => !reserva[k] && reserva[k] !== undefined && delete reserva[k]
            );
          });
          this.reservas = data.data.items;
          this.filtrado = data.data.items;
          this.totalRows = this.pageSizeSelected == -1 ? 1 : data.data.total;
        } else {
          this.error = true;
          this.error_msg =
            "No se ha podido buscar las reservas. Vuelva a intentar mas tarde";
        }
      });
    },
    limpiarFiltros() {
      this.fechaDesde = '';
      this.fechaHasta = '';
      this.estadoSelec = '';
      this.email = '';
      this.telefono = '';
      this.fechaOpcion = null;
      this.buscarPor = '';
      this.buscarPorMedio = '';
      //this.buscar(1);
    },
    formatoFecha(inputDate) {
      if (inputDate != null) {
        var from = inputDate.split("-")
        return new Date(from[2], from[1] - 1, from[0]).getTime()
      }
    },
    verReserva(reserva_id, email) {
      localStorage.setItem("reserva_id", reserva_id);
      localStorage.setItem("cliente_email", email);
      this.$router.push({ name: "VerReserva" });
    },
    fechaDeHoy() {
      let date = new Date();
      return (
        "" +
        date.getFullYear() +
        (date.getMonth() + 1 > 9 ? "" : "0") +
        (date.getMonth() + 1) +
        (date.getDate() > 9 ? "" : "0") +
        date.getDate()
      );
    },
    exportarPDF(page) {
      this.currentPage = page;
      let request = {
        size: this.pageSizeSelected,
        page: page - 1,
        telefono: this.telefono,
        email: this.email,
        fechaOpcion: this.fechaOpcion,
        buscarPorRegistro: this.buscarPor === 'registro',
        buscarPorReserva: this.buscarPor === 'reserva',
        estado: this.estadoSelec



      };
      axios.get("/exportPDFReservas?" + this.convertDataObjectUrl(request),
        {
          responseType: 'arraybuffer'
        }
      ).then((data) => {
        if (data.status == 200) {
          var blob = new Blob([data.data], { type: "application/pdf;charset=utf-8" });
          saveAs(blob, "reservas.pdf");

        } else {
          this.error = true;
          this.error_msg =
            "No se ha podido buscar las reservas. Vuelva a intentar mas tarde";
        }
      });
    },
  },

  beforeMount() {
    this.buscar(1);
    this.filename = "reservas-" + this.fechaDeHoy();
    axios.get("/getTodosLosEstados/").then((data) => {
      if (data.status == 200) {
        data.data.forEach((estado) => {

          if (estado == "PENDIENTE") {
            estado = "PENDIENTE";
          }
          this.estados.push(estado)

        });
      } else {
        this.error = true;
        this.error_msg =
          "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
      }
    });
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}

body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}

.mx-datepicker-range {
  width: 150px !important
}
</style>
